import { Box, Skeleton } from "@mui/material";
import React from "react";

export const GoalSkeleton = ({ count = 10 }) => {
  return (
    <Box p={1}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={60}
          animation={false} // disable default animation
          sx={{
            mb: 1.5,
            // borderRadius: 2,
            background: `linear-gradient(110deg, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%)`,
            backgroundSize: "200% 100%",
            animation: "shimmer 0.8s linear infinite",
          }}
        />
      ))}
    </Box>
  );
};

// Custom shimmer keyframes using global CSS
const shimmerStyle = document.createElement("style");
shimmerStyle.innerHTML = `
@keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
}
`;
document.head.appendChild(shimmerStyle);

export const ChartSkeleton = ({ count = 5 }) => {
  return (
    <Box
      display="flex"
      alignItems="flex-end"
      justifyContent={"center"}
      gap={1}
      p={2}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width={40}
          height={Math.floor(Math.random() * 200) + 40} // Random height between 40–100
          animation="wave"
          sx={{ borderRadius: 1, animation: "shimmer 0.8s linear infinite" }}
        />
      ))}
    </Box>
  );
};

export const GoalFilterStatusSkeleton = ({ count = 20 }) => {
  return (
    <Box display={"flex"} sx={{ gap: 1 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={150}
          height={50}
          animation={false} // disable default animation
          sx={{
            background: `linear-gradient(110deg, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%)`,
            backgroundSize: "200% 100%",
            animation: "shimmer 0.8s linear infinite",
          }}
        />
      ))}
    </Box>
  );
};
